module.exports = __webpack_public_path__ + "img/img_18.dffa9888.png";